import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { PaginationInstance } from 'ngx-pagination';

import { LmsPaginateComponent } from '../lms-paginate';

@Component({
  selector: 'lms-table-wrapper',
  standalone: true,
  imports: [CommonModule, LmsPaginateComponent],
  template: `
    <section class="lms-table-wrapper">
      <div class="lms-table-content">
        <ng-content></ng-content>
      </div>

      <lms-paginate
        *ngIf="paginatorVisible"
        [config]="config"
        [items]="items ?? []"
        (changePaged)="changePaged.emit($event)">
      </lms-paginate>
    </section>
  `,
  styleUrls: ['./lms-table-wrapper.component.scss'],
})
export class LmsTableWrapperComponent {
  @Input() items?: unknown[];

  @Input() config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 10,
    currentPage: 1,
  };

  @Input() showPaginator?: boolean;

  paginatorVisible = true;

  @Output() changePaged = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges): void {
    // Check if either items or config has changed
    if (changes['items'] || changes['config'] || changes['showPaginator']) {
      this.updatePaginatorVisibility();
    }
  }

  private updatePaginatorVisibility(): void {
    if (this.showPaginator === false) {
      this.paginatorVisible = false;
      return;
    }

    if (this.showPaginator === true) {
      this.paginatorVisible = true;
      return;
    }

    if (this.items === undefined) {
      this.paginatorVisible = true;
      return;
    }

    const itemCount = this.items?.length ?? 0;
    const itemsPerPage = this.config.itemsPerPage ?? 10;

    // Logic: Only show if there are more items than the capacity of one page
    this.paginatorVisible = itemCount > itemsPerPage;
  }
}
